import { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LatestJobs } from "@/components/LatestJobs";
import { AskExpertsAside } from "@/components/AskExpertsAside";
import clsx from "classnames";
import styles from "./styles.module.scss";

function EpisodeEmbed({ embedCode }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!embedCode || !containerRef.current) return;

    containerRef.current.innerHTML = embedCode;

    const scripts = containerRef.current.querySelectorAll("script");
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }, [embedCode]);

  return <div ref={containerRef} className={styles.iframeContainer} />;
}

export const Text = ({
  className,
  content,
  podcastEmbed,
  showLatestJobs,
  showAskExperts,
}) => (
  <div className={clsx(className, styles.text)}>
    <Container fluid="lg" className="py-5 py-md-6">
      <Row>
        <Col xs={12} md={9}>
          {content && <div dangerouslySetInnerHTML={{ __html: content }} />}

          {podcastEmbed && (
            <div className="mb-5">
              <EpisodeEmbed embedCode={podcastEmbed} />
            </div>
          )}
        </Col>

        <Col xs={12} md={3}>
          {showLatestJobs && <LatestJobs className="mb-4" limit={1} />}
          {showAskExperts && <AskExpertsAside />}
        </Col>
      </Row>
    </Container>
  </div>
);

export default Text;
